// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/versionManage',
    name: 'versionManage',
    component: layout,
    redirect: '/versionManage/index',
    meta: {
      title: '版本管理',
      roles: [0]
    },
    sort: 5,
    children: [
      {
        path: 'index',
        name: 'VersionManageIndex',
        component: () => import('@/views/Manage/Version.vue'),
        meta: {
          title: '版本列表',
          icon: 'i-tabler:pig-money',
          roles: [0]
        }
      }
    ]
  }
]
export default routes
